import { html, css, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { map } from "lit/directives/map.js";

type ButtonDef = {
	id: string;
	name: string;
	checked?: boolean;
}

@customElement('rp-filters-buttongrid')
export class ButtonGrid extends LitElement {

	static styles = css`
		* {
			box-sizing: border-box;
		}

		:host {
			display: block;
			position: relative;
			overflow: hidden;
			padding: 3px;
		}

		.row {
			display: flex;
			width: 100%;
		}

		og-button {
			border: 1px solid var(--og-border-color);
			flex: 1; text-align: center
		}
	`;

	@property({type: Number})
	columns: number = 5;

	@property({type: Array})
	buttons: ButtonDef[];

	get values() {
		return new Set(this.buttons.filter(b => b.checked).map(b => b.id));
	}

	_onClick = (index: number) => {
		this.buttons[index].checked = !this.buttons[index].checked;
		this.dispatchEvent(new Event('change'));
	}

	buttonGrid(): [number, ButtonDef][][] {
		const result: [number, ButtonDef][][] = [];
		for (let i = 0; i < this.buttons?.length || 0; i += this.columns) {
			result.push(this.buttons.slice(i, i + this.columns).map((b, j) => [i, b]));
		}
		return result;
	}

	render = () => html`
		${map(this.buttonGrid(), row => html`
			<div class="row">
				${map(row, button => html`
					<og-button
						text="${button[1].name}"
						type="toggle"
						?state="${!!button[1].checked}"
						@click="${() => this._onClick(button[0])}">
					</og-button>
				`)}
			</div>
		`)}
	`;

}
